import { FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import './TextLink.scss';

interface Props {
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  isColorLink?: boolean;
}

export const TextLink: FunctionComponent<Props & { href: string }> = ({
  className,
  children,
  href,
  onClick,
  isColorLink = true,
}) => (
  <a
    className={cn(className, isColorLink ? 'sprd-text-link' : '')}
    href={href}
    rel="noopener noreferrer"
    target="_blank"
    onClick={onClick}
  >
    {children}
  </a>
);

export const TextRouterLink: FunctionComponent<Props & { to: string }> = ({
  className,
  children,
  to,
  onClick,
  isColorLink = true,
}) => (
  <Link className={cn(className, isColorLink ? 'sprd-text-link' : '')} to={to} onClick={onClick}>
    {children}
  </Link>
);
